import { render, staticRenderFns } from "./PointsResultComponent.vue?vue&type=template&id=e570afde&scoped=true"
import script from "./PointsResultComponent.vue?vue&type=script&lang=ts"
export * from "./PointsResultComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e570afde",
  null
  
)

export default component.exports